//? section1
import image1 from "./assets/service1.png";
import image2 from "./assets/service2.png";
import image3 from "./assets/service3.png";
import image4 from "./assets/service4.png";
//? section2
import image5 from "./assets/why-choose.jpg";
import icon from "./assets/check_box_outlined@2x.png";
//? section3
import image6 from "./assets/t1.jpg";
import image7 from "./assets/t2.jpg";
import image8 from "./assets/t3.jpg";
//? section4
import image9 from "./assets/appointment.jpg";

import logo from "./assets/logo.png";
import headerBackground from "./assets/banner-bg.jpg";
import faceOfHeader from "./assets/banner-left.png";

export const headerImages = {
  logo,
  headerBackground,
  faceOfHeader,
};
export const section1Data = [
  {
    id: 1,
    title: "Criminal Law",
    description:
      "Design becoming like this is one of your goals here are some great pointers",
    image: image1,
  },
  {
    id: 2,
    title: "Business Law",
    description:
      "Design becoming like this is one of your goals here are some great pointers",
    image: image2,
  },
  {
    id: 3,
    title: "Divorce Law",
    description:
      "Design becoming like this is one of your goals here are some great pointers",
    image: image3,
  },
  {
    id: 4,
    title: "Trademark Law",
    description:
      "Design becoming like this is one of your goals here are some great pointers",
    image: image4,
  },
];

export const section2Data = {
  whyChooseImage: image5,
  headerText: "Why Choose Our Legal Service",
  paragraphText:
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum eos quam eligendi optio cumque. Consectetur repellat officia obcaecati, quod deserunt cumque nisi recusandae neque odio, mollitia natus nemo id minima!",
  listItems: [
    {
      id: 1,
      text: "Adopting A Baby",
      icon,
    },
    {
      id: 2,
      text: "Who can Adopt",
      icon,
    },
    {
      id: 3,
      text: "Supports from Adopters",
      icon,
    },
  ],
};

export const section3Data = [
  {
    id: 1,
    name: "Jason Mathew",
    about:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Officiis, numquam!",
    image: image6,
  },
  {
    id: 2,
    name: "Richard Howk",
    about:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Officiis, numquam!",
    image: image7,
  },
  {
    id: 3,
    name: "Anderson Job",
    about:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Officiis, numquam!",
    image: image8,
  },
];

export const section4Image = image9;

export const section5Data = [
  {
    id: 1,
    name: "John Smith",
    location: "Seatle Washington",
    about:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis at laudantium rerum tenetur commodi mollitia, harum repellendus deserunt consequuntur magni reiciendis iste ipsa, nisi, illum animi dolore quo dolorum hic ratione quae et consequatur totam reprehenderit? Enim, nobis molestiae. Praesentium.",
    image: image7,
  },
  {
    id: 2,
    name: "John Smith",
    location: "Seatle Washington",
    about:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis at laudantium rerum tenetur commodi mollitia, harum repellendus deserunt consequuntur magni reiciendis iste ipsa, nisi, illum animi dolore quo dolorum hic ratione quae et consequatur totam reprehenderit? Enim, nobis molestiae. Praesentium.",
    image: image8,
  },
];
